import { render } from "./Loiality.vue?vue&type=template&id=f168ab08&scoped=true"
import script from "./Loiality.vue?vue&type=script&lang=js"
export * from "./Loiality.vue?vue&type=script&lang=js"

import "./Loiality.vue?vue&type=style&index=0&id=f168ab08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f168ab08"]])

export default __exports__